import Vue from 'vue';
import VueMask from 'v-mask';

Vue.use(VueMask, {
  tokens: {
    '#': { pattern: /\d/ },
    X: { pattern: /[0-9a-zA-Z]/ },
    N: {
      pattern: /[0-9A-Za-z]/,
      transform: (v) => v.toLocaleUpperCase()
    },
    S: { pattern: /[a-zA-Z]/ },
    A: {
      pattern: /[a-zA-Z]/,
      transform: (v) => v.toLocaleUpperCase()
    },
    a: {
      pattern: /[a-zA-Z]/,
      transform: (v) => v.toLocaleLowerCase()
    },
    '!': { escape: true }
  }
});
